import {
  AssetType,
  ZapMetadata,
  DisplayLinkAsType,
} from "@zapier/canvas-state";
import { FloatingZapsTypeahead } from "../FloatingZapsTypeahead";
import { FloatingTablesTypeahead } from "../FloatingTablesTypeahead";
import { FloatingChatbotsTypeahead } from "../FloatingChatbotsTypeahead";
import { FloatingInterfacesAndPagesTypeaheads } from "../FloatingInterfacesAndPagesTypeaheads";
import { FloatingLinkEmbed } from "../FloatingLinkEmbed";
import { FloatingAgentsTypeahead } from "../FloatingAgentsTypeahead";

type Props = {
  zap?: ZapMetadata;
  hasZap?: boolean;
  isZapNotFound?: boolean;
  assetType: AssetType | undefined;
  link: string | undefined;
  displayLinkAs?: DisplayLinkAsType;
  assetIds:
    | {
        tableId?: string;
        interfaceProjectId?: string;
        interfacePageId?: string;
        chatbotId?: string;
        agentId?: string;
      }
    | undefined;
};

export function FloatingLinkController({
  zap,
  hasZap,
  isZapNotFound,
  assetType,
  link,
  displayLinkAs,
  assetIds,
}: Props) {
  const tableId = assetIds?.tableId;
  const chatbotId = assetIds?.chatbotId;
  const interfaceProjectId = assetIds?.interfaceProjectId;
  const interfacePageId = assetIds?.interfacePageId;
  const agentId = assetIds?.agentId;

  if (assetType === "interface") {
    return (
      <FloatingInterfacesAndPagesTypeaheads
        interfaceProjectId={interfaceProjectId}
        interfacePageId={interfacePageId}
      />
    );
  }

  if (assetType === "table") {
    return <FloatingTablesTypeahead selectedTableId={tableId} />;
  }

  if (assetType === "chatbot") {
    return <FloatingChatbotsTypeahead selectedChatbotId={chatbotId} />;
  }

  if (assetType === "zap") {
    return (
      <FloatingZapsTypeahead
        zapTitle={zap?.title}
        hasZap={hasZap}
        isZapNotFound={isZapNotFound}
      />
    );
  }

  if (assetType === "agent") {
    return <FloatingAgentsTypeahead selectedAgentId={agentId} />;
  }

  return <FloatingLinkEmbed link={link} displayLinkAs={displayLinkAs} />;
}
